import {Promise, strings} from "@securionpay-internal/commons-js";
import EventEmitter from "./EventEmitter";
import messagePoster from "./messagePoster";
import {COMPANY_NAME} from "../env";
import {encodeFrameParams} from '../utils/frameParams';

export interface ImplicitFrameParams {
    referrer: string
    controllerId: string
}

export default class Frame extends EventEmitter {

    _controllerId: string;
    id: string;
    src: string;
    loaded: boolean;
    queuedMessages: any[];
    _requests: any;
    _iframe: HTMLIFrameElement;

    constructor(src: string, controllerId: string, params?: any) {
        super();
        this._controllerId = controllerId;
        this.id = this._generateId();
        this.src = src;
        this.loaded = false;
        this.on("load", () => {
            this.loaded = true;
            this.queuedMessages.forEach(this._send.bind(this));
            this.queuedMessages = [];
        });
        this.queuedMessages = [];
        this._requests = {};
        this._iframe = this._createIframe(params);
    }

    _isMounted() {
        return !!document.body && document.body.contains(this._iframe);
    }

    appendTo(container) {
        container.appendChild(this._iframe);
    }

    unmount() {
        this.loaded = false;
        this.emit("unload");
    }

    destroy() {
        this.unmount();
        let parent = this._iframe.parentElement;
        if (parent) {
            parent.removeChild(this._iframe);
            this.emit("destroy");
        }
    }

    action(type, options) {
        let requestId = strings.unique(type);
        let promise = new Promise((resolve, reject) => {
            this._requests[requestId] = {
                resolve,
                reject
            }
        });

        this.send({
            action: "securionpay-frame-action",
            payload: {requestId, type, options}
        });

        return promise;
    }

    resolve(requestId, payload) {
        let request = this._requests[requestId];
        if (request) {
            request.resolve(payload);
        }
    }

    send(message) {
        this._send({frameId: this.id, controllerId: this._controllerId, message});
    }

    _send(message) {
        if (this.loaded) {
            messagePoster.framePostMessage(message);
        } else {
            this.queuedMessages.push(message);
        }
    }

    focus() {
      this._iframe.focus();
      this.send({action: "securionpay-user-focus"})
    }

    _generateId() {
        return strings.unique(`__private${COMPANY_NAME}Frame`);
    }

    _createIframe(params = {}) {
        let iframe = document.createElement("iframe");
        iframe.setAttribute("allowTransparency", "true");
        iframe.setAttribute("scrolling", "no");
        iframe.setAttribute("frameborder", "0");
        iframe.setAttribute("name", this.id);

        const frameParams = {
            referrer: window.location.href.toString(),
            controllerId: this._controllerId,
            ...params
        };

        iframe.src = this.src + "#" + encodeFrameParams(frameParams);

        return iframe;
    }
}